export default "__VITE_ASSET__b1966989__"